import { MoneyString } from 'model/Money'
import { RootAppState } from 'store/configureStore'

export const projectGrossSalesPriceSelector = (state: RootAppState) =>
  MoneyString(state.project.activeProject?.financial.costPriceOfItems)

export const projectCostPriceSelector = (state: RootAppState) =>
  state.project.activeProject?.financial?.costPriceOfItems
